import { render, staticRenderFns } from "./processMovement.vue?vue&type=template&id=20eb734d&"
import script from "./processMovement.vue?vue&type=script&lang=js&"
export * from "./processMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports